const openIntercomChat = (): void => {
    window?.Intercom?.('show')
}

export { openIntercomChat }
